import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia previa en marketing digital?',
    a: 'No. Link Academy está diseñada para personas que empiezan desde cero y también para quienes ya tienen conocimientos pero necesitan estructura.'
  }, {
    q: '¿Qué es Alice App?',
    a: 'Alice es una herramienta de inteligencia artificial creada para ayudarte a generar estrategias de marketing según tu negocio, audiencia y objetivo.'
  }, {
    q: '¿Dónde está alojada la comunidad?',
    a: 'La comunidad está en Skool, donde encontrarás cursos, publicaciones, mentorías y recursos.'
  }, {
    q: '¿Puedo usar Link Academy si vivo fuera de LATAM?',
    a: 'Sí. Está pensada para personas hispanohablantes en LATAM, España, Estados Unidos y cualquier país.'
  }, {
    q: '¿Esto es solo un curso?',
    a: 'No. Link Academy combina cursos, comunidad, mentorías y herramientas con IA para ayudarte a ejecutar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-12 lg:py-16 bg-gray-50" data-id="element-70">
      <div className="container mx-auto px-4 md:px-6" data-id="element-71">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-bold text-link-dark mb-6" data-id="element-73">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-74">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-id="element-75">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-76">
                <span className="font-bold text-link-dark pr-8" data-id="element-77">{faq.q}</span>
                <ChevronDown className={`text-link-blue flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-78" />
              </button>

              <AnimatePresence data-id="element-79">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-80">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-81">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}